import { render, staticRenderFns } from "./TdxBaseInput.vue?vue&type=template&id=5dfd9408&scoped=true&"
import script from "./TdxBaseInput.vue?vue&type=script&lang=js&"
export * from "./TdxBaseInput.vue?vue&type=script&lang=js&"
import style0 from "./TdxBaseInput.vue?vue&type=style&index=0&id=5dfd9408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfd9408",
  null
  
)

export default component.exports